module.exports = __webpack_public_path__ + "img/walmart.9b5b92e6.png";